// MigrationModal.tsx
import React from 'react';
import Modal from './Modal';
import Button from './PendantButton';
import { COLOR } from './shared/shared';
import { MigrationDiff } from './helpers/config-migrate';

interface MigrationModalProps {
	title: string;
	migrations: Record<string, MigrationDiff>;
	onConfirm: () => void;
	onCancel: () => void;
}

export const MigrationModal: React.FC<MigrationModalProps> = ({
	title,
	migrations,
	onConfirm,
	onCancel,
}) => {
	return (
		<Modal close={() => {onCancel}}>
			<div
				className="Confirm double-padding flex-col flex-between"
				style={{ width: '35vw' }}
			>
				{/* Header */}
				<span className="font-5 color-blue text-align-center">{title}</span>

				{/* Scrollable content */}
				<div
					className="double-padding"
					style={{
						maxHeight: '300px',
						overflowY: 'auto',
						border: '1px solid #dde2e6',
						borderRadius: '6px',
					}}
				>
					{Object.entries(migrations).map(([file, diff]) => {
						const adds = diff.additions ?? [];
						const drops = diff.removals ?? [];

						return (
							<div key={file} className="margin-bottom">
								<strong className="font-4 color-blue">{file}</strong>

								{adds.length > 0 && (
									<>
										<div className="font-3 color-green">To be added:</div>
										<ul>
											{adds.map((m, i) => (
												<li key={i}>{m.path}</li>
											))}
										</ul>
									</>
								)}

								{drops.length > 0 && (
									<>
										<div className="font-3 color-red">To be removed:</div>
										<ul>
											{drops.map((p, i) => (
												<li key={i}>{p}</li>
											))}
										</ul>
									</>
								)}
							</div>
						);
					})}
				</div>

				{/* Buttons */}
				<div className="flex-row flex-between" style={{ marginTop: '1em' }}>
					<Button className="double-padding vw-12" pAction={onCancel}>
						Cancel Upload
					</Button>
					<Button
						className="double-padding vw-12"
						pAction={onConfirm}
						pNormalColorOverride={COLOR.LIGHT_BLUE}
					>
						Fix & Upload
					</Button>
				</div>
			</div>
		</Modal>
	);
};
